import keyMirror from 'keymirror';

export default keyMirror({
    CATEGORIES_FETCHED: null,
    KEYWORDS_FETCHED: null,
    ENCODERS_FETCHED: null,
    ASSETS_FETCHED: null,
    MISC_ASSETS_FETCHED: null,
    ANALYTICS_FETCHED: null,
    TECHNICIANS_FETCHED: null,
    LOCATIONS_FETCHED: null,
    REQUEST_SCHEDULES: null,
    FETCHED_SCHEDULES: null,
    REFETCH: null
});
